import { createBrowserRouter, Navigate } from 'react-router-dom';
import DashboardLayout from './components/DashboardLayout';
import ProtectedRoute from './components/ProtectedRoute';
import ChangePassword from './pages/ChangePassword';
import Landing from './pages/Landing';
import AnnouncementsPage from './pages/dashboard/announcements/AnnouncementsPage';
import AttendancePage from './pages/dashboard/attendance/AttendancePage';
import BehaviorPage from './pages/dashboard/behavior/BehaviorPage';
import CalendarPage from './pages/dashboard/calendar/CalendarPage';
import ChatPage from './pages/dashboard/chat/ChatPage';
import DashboardHome from './pages/dashboard/DashboardHome';
import EnrollmentsPage from './pages/dashboard/enrollments/EnrollmentsPage';
import ExpensesPage from './pages/dashboard/expenses/ExpensesPage';
import FinanceDashboard from './pages/dashboard/fees/FinanceDashboard';
import FinancePage from './pages/dashboard/fees/FinancePage';
import GradesPage from './pages/dashboard/grades/GradesPage';
import HealthPage from './pages/dashboard/health/HealthPage';
import HomeworkPage from './pages/dashboard/homework/HomeworkPage';
import MealsPage from './pages/dashboard/meals/MealsPage';
import ParentPage from './pages/dashboard/parent/ParentPage';
import PollsPage from './pages/dashboard/polls/PollsPage';
import ProfilePage from './pages/dashboard/profile/ProfilePage';
import ReportsPage from './pages/dashboard/reports/ReportsPage';
import SchedulesPage from './pages/dashboard/schedules/SchedulesPage';
import SecurityPage from './pages/dashboard/security/SecurityPage';
import SettingsPage from './pages/dashboard/settings/SettingsPage';
import StaffPage from './pages/dashboard/staff/StaffPage';
import StudentDetailPage from './pages/dashboard/students/StudentDetailPage';
import StudentsPage from './pages/dashboard/students/StudentsPage';
import TeacherPage from './pages/dashboard/teacher/TeacherPage';
import TicketsPage from './pages/dashboard/tickets/TicketsPage';
import Login from './pages/Login';
import SuperAdminLogin from './pages/SuperAdminLogin';
import SuperAdminDashboard from './pages/super-admin/Dashboard';
import SuperAdminProfilePage from './pages/super-admin/profile/ProfilePage';
import SchoolsPage from './pages/super-admin/schools/SchoolsPage';
import UsersPage from './pages/super-admin/users/UsersPage';

function NotFound() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>404</h1>
      <p>Página no encontrada</p>
      <a href="/login">Ir al inicio</a>
    </div>
  );
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Landing />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/change-password',
    element: <ChangePassword />,
  },
  {
    path: '/super-admin/login',
    element: <SuperAdminLogin />,
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DashboardHome /> },
      { path: 'students', element: <StudentsPage /> },
      { path: 'students/:id', element: <StudentDetailPage /> },
      { path: 'enrollments', element: <EnrollmentsPage /> },
      { path: 'security', element: <SecurityPage /> },
      { path: 'meals', element: <MealsPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'finance', element: <Navigate to="finance/pagos" replace /> },
      { path: 'finance/pagos', element: <FinancePage /> },
      { path: 'finance/tablero', element: <FinanceDashboard /> },
      { path: 'attendance', element: <AttendancePage /> },
      { path: 'grades', element: <GradesPage /> },
      { path: 'behavior', element: <BehaviorPage /> },
      { path: 'health', element: <HealthPage /> },
      { path: 'tickets', element: <TicketsPage /> },
      { path: 'tickets/:id', element: <TicketsPage /> },
      { path: 'announcements', element: <AnnouncementsPage /> },
      { path: 'chat', element: <ChatPage /> },
      { path: 'calendar', element: <CalendarPage /> },
      { path: 'parent', element: <ParentPage /> },
      { path: 'teacher', element: <TeacherPage /> },
      { path: 'polls', element: <PollsPage /> },
      { path: 'homework', element: <HomeworkPage /> },
      { path: 'reports', element: <ReportsPage /> },
      { path: 'schedules', element: <SchedulesPage /> },
      { path: 'staff', element: <StaffPage /> },
      { path: 'expenses', element: <ExpensesPage /> },
      { path: 'profile', element: <ProfilePage /> },
    ],
  },
  {
    path: '/super-admin',
    element: (
      <ProtectedRoute requireSuperAdmin>
        <SuperAdminDashboard />
      </ProtectedRoute>
    ),
    children: [
      { path: 'schools', element: <SchoolsPage /> },
      { path: 'users', element: <UsersPage /> },
      { path: 'profile', element: <SuperAdminProfilePage /> },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);
